import { Link, LinkProps } from "react-router-dom";
import { CSSProperties } from "react";
import { usePalette } from "@/shared/theme";

export function LinkForTitle(props: LinkProps) {
  const palette = usePalette();

  return (
    <Link
      className={"!text-[--color]"}
      style={
        {
          "--color": palette.primary[5],
        } as CSSProperties
      }
      {...props}
    />
  );
}
